import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('bricks_brain_admin_token');
    localStorage.removeItem('admin_login_time');
    navigate('/admin/login');
  };

  const logoutButtonStyle = {
    display: 'inline-block',
    padding: '0.85rem 2.5rem',
    backgroundColor: '#e74c3c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '1rem',
    fontFamily: 'inherit',
    letterSpacing: '0.5px',
    boxShadow: '0 2px 8px rgba(231, 76, 60, 0.3)',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    minWidth: '120px',
    textAlign: 'center',
    marginTop: '1rem'
  };

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <div className="header-content">
          <h1>Admin Dashboard</h1>
          <p>Welcome to Bricks & Brain Admin Panel</p>
        </div>
        <button 
          onClick={handleLogout} 
          style={logoutButtonStyle}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#c0392b';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#e74c3c';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          Logout
        </button>
      </div>
      
      <div className="dashboard-cards">
        <Link to="/admin/invoice" className="dashboard-card">
          <div className="card-icon">📄</div>
          <h3>Create Invoice</h3>
          <p>Generate and manage invoices for your clients</p>
        </Link>
        
        <Link to="/admin/quotation" className="dashboard-card">
          <div className="card-icon">📋</div>
          <h3>Create Quotation</h3>
          <p>Create professional quotations for projects</p>
        </Link>
      </div>
    </div>
  );
};

export default AdminDashboard;
